<template>
  <div class="font-inter" id="my-account">
    <div class="d-flex">
      <div class="flex-grow-1 bd-highlight">
        <BaseHeader :title="$t('views.seller.my_account.text_1143')"></BaseHeader>
        <b-breadcrumb :items="breadcrumbItems" class="bg-white m-0 p-0"></b-breadcrumb>
      </div>
    </div>

    <b-tabs class="mt-4" nav-class="TabHeader" active-nav-item-class="TabHeader--active" :no-nav-style="true">
      <b-tab id="user" :title="`${$t('views.seller.my_account.text_1230')}`" :active="activeIndex === 0">
        <b-container fluid class="container-user" v-show="!loading">
          <MyProfileTab :user="user" :userData="dados_user" :statusValidation="status_validation" :onSubmit="onSubmit"
            :userImage="this.help_foto" :uploadImage="uploadImageSuccess"/>
        </b-container>
      </b-tab>

      <b-tab id="financial-data" :title="`${$t('views.seller.my_account.text_1231')}`" :active="activeIndex === 1">
        <template #title>
          {{ $t('views.seller.my_account.text_1231') }}
          <span
            v-if="(getFinancialDataStatus === 'pending' || getFinancialDataStatus === 'in_progress')" 
            class="tag-status" 
            :class="getFinancialDataStatus"
          >
            {{ $t('views.seller.my_account.status.' + getFinancialDataStatus) }}
          </span>
        </template>
        <b-container fluid class="container-user" v-show="!loading">
          <FinancialDataTab />
        </b-container>
      </b-tab>

      <b-tab id="my-fees" :title="$t('views.seller.my_account.text_1245')" :active="activeIndex === 2">
        <b-container fluid class="container-user" v-show="!loading">
          <MyFeesTab />
        </b-container>
      </b-tab>

      <b-tab id="security" :title="$t('views.seller.my_account.text_1246')" :active="activeIndex === 3">
        <b-container fluid class="container-user" v-show="!loading">
          <SecurityTab :user="user" />
        </b-container>
      </b-tab>

      <div key="loading" v-if="loading" class="py-5 my-5 d-flex justify-content-center align-items-center">
        <BaseLoading />
      </div>
    </b-tabs>
    <ResetPassword :user_id="user.id" />
    <AndamentoDocs :docs="andamento" />
    <ModalValidation @close="initDados" />
  </div>
</template>
<script>
import ResetPassword from "@/components/Seller/MyAccount/modals/reset_password.vue";
import AndamentoDocs from "@/components/Seller/MyAccount/modals/AndamentoDocs.vue";
import MyProfileTab from '@/components/Seller/MyAccount/MyProfileTab.vue';
import FinancialDataTab from '@/components/Seller/MyAccount/FinancialDataTab.vue';
import MyFeesTab from '@/components/Seller/MyAccount/MyFeesTab.vue';
import SecurityTab from '@/components/Seller/MyAccount/SecurityTab.vue';

import UserService from "@/services/resources/UserService";
const serviceUser = UserService.build();

import ValidationService from "@/services/resources/ValidationService";
const serviceValidation = ValidationService.build();

import Locales from "@/components/Locales";

export default {
  data() {
    return {
      activeTab: null,
      dados_user: {},
      loading: false,
      submit: false,
      bankAccount: null,
      status_validation: {
        status: "",
        observation: "",
      },
      foto_user: [],
      help_foto: [],
      document_user: [],
      contract_user: null,
      changeContract: false,
      troca_senha: false,
      andamento: [],
      user: {
        id: -1,
        name: "",
        cellphone: "",
        email: "",
        cpf_cnpj: "",
        rg: "",
        image: [],
        documents: [
          {
            status: "REQUESTED",
          },
        ],
        old_password: "",
        new_password: "",
      },
      address_user: {
        zip_code: "00000-000",
        street: "",
        number: "",
        neighborhood: "",
        city: "",
        state: "",
      },
      company: {
        last_document: {},
        documents: [
          {
            status: "APPROVED",
          },
        ],
        name: "",
        fantasy_name: "",
        telephone: "",
        support_telephone: "",
        email: "",
        cnpj: "",
        zip_code: "00000-000",
        street: "",
        number: "",
        neighborhood: "",
        city: "",
        state: "",
      },
      emailError: false
    };
  },
  components: {
    ResetPassword,
    AndamentoDocs,
    Locales,
    MyProfileTab,
    FinancialDataTab,
    MyFeesTab,
    SecurityTab
  },
  computed: {
    userId() {
      return this.$store.getters.getProfile.id;
    },
    activeIndex() {
      return this.activeTab;
    },
    breadcrumbItems() {
      return [
        { text: 'Dashboard', href: '/dashboard' },
        { text: this.$t('views.seller.my_account.text_1143') },
        { text: this.$t('views.seller.my_account.text_1230') }
      ];
    },
    getFinancialDataStatus() {
      if (this.bankAccount === null) {
        return 'pending';
      }
      if (this.bankAccount.status === 'DISAPPROVED') {
        return 'pending';
      }
      if (this.bankAccount.status === 'PROCESSING') {
        return 'in_progress';
      }
      return 'finish';
    }
  },
  methods: {
    openTab(number) {
      this.activeTab = number;
    },

    checkStatus(docs, status) {
      if (docs.length) {
        return docs.filter((item) => item.status == status);
      } else return [];
    },
    // foto usuario
    uploadImageSuccess(formData, index, fileList) {
      this.foto_user = fileList;
      this.help_foto = fileList;
    },

    buildFormData(formData, data, parentKey) {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          );
        });
      } else {
        const value = data == null ? "" : data;

        formData.append(parentKey, value);
      }
    },

    jsonToFormData(data) {
      const formData = new FormData();
      this.buildFormData(formData, data);
      return formData;
    },
    onSubmit(tipo, formData = null) {
      if (formData) {
        this.user = formData
        this.address_user = formData.address;
        this.document_user = formData.documents;
        this.company = formData.company || this.company;
        if (formData.company) {
          this.changeContract = !!(formData.company.documents.length);
        }
      }

      if (this.company.email && this.company.email.trim() !== '') {
        this.validateEmail();
      }

      if (this.emailError) {
        return;
      }
      this.submit = true;
      this.loading = true;

      this.$validator.validateAll(tipo).then(async (result) => {
        if (result) {
          let data = {
            id: this.user.id,
            company: {},
          };
          if (tipo == "user") {
            data = this.user;
            data.address = this.address_user;
            data.image = this.foto_user[0];
            data.documents = this.document_user;
            delete data.company;
          }
          
          if (tipo == "company") {
            data.company = this.company;
            if (!this.changeContract) {
              data.company.documents = [];
            }
          }

          data._method = "PUT";
          data = this.jsonToFormData(data);

          serviceUser
            .create(data, this.user.id)
            .then(() => {
              // resetando coockie
              this.initDados();

              if (tipo == "user") {
                this.user.documents = [{ status: "REQUESTED" }];
              } 
              
              if (tipo == "company") {
                this.company.documents = [{ status: "REQUESTED" }];
              }

              this.$bvToast.toast(
                this.$t("views.seller.my_account.text_1197"),
                {
                  title: this.$t("views.seller.my_account.text_1198"),
                  variant: "success",
                  autoHideDelay: 5000,
                  appendToast: true,
                }
              );
            })
            .catch((error) => {
              if (tipo == "company") {
                this.company.contract = null;
              }
              console.log(error);
            })
            .finally(() => {
              this.loading = false;
              this.submit = false;
            });
        } else {
          this.loading = false;
          this.$bvToast.toast(this.$t("views.seller.my_account.text_1199"), {
            title: this.$t("views.seller.my_account.text_1198"),
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      });
    },

    async getStatusValidation(id) {
      try {
        const response = await serviceValidation.read({ id });
        
        this.status_validation = response;

        if (!this.status_validation.status) {
          this.status_validation = {
            status: "INITIATED",
            observation: "",
            ...response
          };
        }
        this.$root.$emit('onload-identity-validation', this.status_validation);
        return this.status_validation;
      } catch (error) {
        return {
          status: 'INITIATED',
          observation: '',
        };
      }
    },
    async setDados() {
      const identityValidation = await this.getStatusValidation(this.dados_user.id);

      this.user = {
        id: this.dados_user.id,
        name: this.dados_user.name,
        cellphone: this.dados_user.cellphone,
        rg: this.dados_user.rg,
        email: this.dados_user.email,
        cpf_cnpj: this.dados_user.cpf_cnpj,
        image: this.dados_user.image,
        documents: this.dados_user.documents || [],
      };

      this.document_user = this.user.documents;

      if (this.user.image) {
        this.help_foto = [
          {
            path: this.user.image,
          },
        ];
      }

      this.address_user = Object.assign({}, this.dados_user.address);

      let dados_company = Object.assign({}, this.dados_user.company);
      this.company = {
        contract: dados_company.contract,
        name: dados_company.name,
        fantasy_name: dados_company.fantasy_name,
        telephone: dados_company.telephone,
        support_telephone: dados_company.support_telephone,
        cnpj: dados_company.cnpj,
        email: dados_company.email,
        zip_code: dados_company.zip_code,
        street: dados_company.street,
        number: dados_company.number,
        neighborhood: dados_company.neighborhood,
        city: dados_company.city,
        state: dados_company.state,
        documents: dados_company.documents || [],
        last_document: dados_company.last_document || {},
      };

      const myAccountData = {
        company: this.company,
        user: this.dados_user,
        onSubmit: this.onSubmit,
        identityValidation
      };

      this.$root.myAccountData = myAccountData;
      this.$root.$emit('onload-my-account', myAccountData);

      this.loading = false;
    },

    initDados() {
      this.loading = true;

      this.$store
        .dispatch("userRequest")
        .then((response) => {
          this.dados_user = Object.assign({}, response);
        })
        .then(() => {
          this.setDados();
        })
        .catch((err) => {
          console.log(err);
          this.dados_user = Object.assign({}, this.$store.state.user.user);
          this.setDados();
        });
    },

    validateEmail() {

      const email = this.company.email;
      let errorMessage = '';

      if (email === '') {
        this.emailError = false;
        return;
      }

      // Expressão regular para validar email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      const commonDomains = [
        'gmail.com', 'hotmail.com', 'yahoo.com',
        'gmail.com.br', 'hotmail.com.br', 'icloud.com',
        'outlook.com', 'yahoo.com.br', 'uol.com.br',
        'live.com', 'terra.com.br', 'bol.com.br',
        'cogna.com.br', 'outlook.com.br', 'kroton.com.br',
        'parceiro-kroton.com.br', 'msn.com', 'usp.br',
        'escola.pr.gov.br', 'anhanguera.com', 'unesp.br',
        'stoodi.com.br', 'mepoupe.com', 'educacao.mg.gov.br',
        'voomp.com.br', 'maildrop.cc'
      ];

      if (!emailRegex.test(email)) {
        errorMessage = this.$t('client.invalid_email');
        this.emailError = true;
      } else {
        const domainPart = email.split('@')[1];
        this.emailError = false;
        if (!commonDomains.includes(domainPart)) {
          const similarDomain = commonDomains.some(domain => this.isSimilarDomain(domain, domainPart));
          if (similarDomain) {
            errorMessage = this.$t('client.invalid_domain');
            this.emailError = true;
          } else {
            this.emailError = false;
          }
        }
      }

    },
    isSimilarDomain(domain1, domain2) {
      const levenshteinDistance = (a, b) => {
        const matrix = [];
        let i;
        for (i = 0; i <= b.length; i++) { matrix[i] = [i]; }
        let j;
        for (j = 0; j <= a.length; j++) { matrix[0][j] = j; }
        for (i = 1; i <= b.length; i++) {
          for (j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
              matrix[i][j] = matrix[i - 1][j - 1];
            } else {
              matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1));
            }
          }
        }
        return matrix[b.length][a.length];
      };

      return levenshteinDistance(domain1, domain2) <= 2;
    },
    handleSaving(loading) {
      this.loading = loading;
      this.submit = loading;
    },
    handleFinish(isFinished) {
      if (isFinished) {
        this.initDados();
      }
    }
  },
  mounted() {
    this.initDados();
    if (this.company.email && this.company.email.trim() !== '') {
      this.validateEmail();
    }
    if (this.$route.query.tab) {
      this.openTab(parseInt(this.$route.query.tab))
    }
  },
  created() {
    this.$root.$on('on-saving', this.handleSaving);
    this.$root.$on('on-finish', this.handleFinish);
    this.$root.$on('onload-bank-account', (bankAccount) => {
      this.bankAccount = bankAccount;
    });
  },
  beforeDestroy() {
    // Remove o listener para evitar vazamentos de memória
    this.$root.$off('on-saving', this.handleSaving);
    this.$root.$off('on-finish', this.handleFinish);
    this.$root.$off('onload-bank-account');
  },
};
</script>

<style>
#my-account .TabHeader {
  display: flex;
  border-bottom: 2px solid transparent;
  gap: 32px;
}

#my-account .TabHeader .nav-item a {
  padding: 0px 4px 16px 4px;
  color: #6B7280;
}

#my-account .TabHeader .nav-item {
  position: relative;
}

#my-account .TabHeader .TabHeader--active {
  color: #0854C5 !important;
}

#my-account .TabHeader .TabHeader--active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #0854C5;
  transition: width 1s;
}

#my-account .info-checkbox {
  margin: 0;
  margin-top: 20px;
  margin-left: 5px;
  font-weight: 500;
}

#my-account .descricao-checkbox {
  display: block;
  margin-top: 5px;
  font-weight: normal;
  color: #81858e;
  font-size: 13px;
  max-width: 80%;
  line-height: 1.5;
}

#my-account .title h5 {
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  color: var(--Default-gray-900, #111827);
}

#my-account .title p {
  font-size: 14px;
  line-height: 20px;
  color: var(--Default-gray-500, #6B7280);
  margin: 0;
}

#my-account p {
  font-size: 14px;
  line-height: 20px;
  color: var(--Default-gray-500, #6B7280);
  margin: 0;
}

#my-account p.bold {
  font-style: normal;
  font-weight: 600 !important;
  color: var(--Default-gray-900, #111827) !important;
}

#my-account .container-user {
  display: flex;
  padding: 48px 200px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
}

@media screen and (max-width: 768px) {
  #my-account .container-user {
    padding: 30px;
  }

  #my-account .bank-account-container {
    padding: 0px;
    border: 0px !important;
    margin-bottom: 20px;
  }
}

#my-account .info-documento {
  margin: 0;
  font-weight: normal;
  color: #81858e;
  font-size: 13px;
  line-height: 1.5;
}

#my-account .info-documento+.info-documento {
  margin-top: 5px;
}

#my-account .btn-2 {
  color: #2a63ab;
  background: rgba(33, 51, 210, 0.1);
  font-size: 12px;
  font-weight: 600;
  padding: 10px 15px;
  border-radius: 5px;
}

#my-account .leading-6 {
  color: var(--Default-gray-900, #111827);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

#my-account .leading-5 {
  color: var(--Default-gray-900, #111827);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.aprovacao {
  display: flex;
  align-items: center;
}

.aprovacao img {
  margin-right: 10px;
}

.DISAPPROVED {
  background: rgba(255, 12, 55, 0.1);
  color: #ff0c37;
}

.APPROVED {
  background: rgba(0, 33, 99, 0.1);
  color: #002363;
}

.link-aprovado {
  font-weight: 600;
  color: #2a63ab;
}

.ver-arquivo {
  font-size: 13px;
  display: inline-block;
  padding: 5px;
}

.top-status {
  display: flex;
  align-items: center;
  gap: 30px;
}

.email-company {
  margin-top: -75px;
}

@media screen and (max-width: 768px) {
  .top-status {
    display: block;
  }

  .ver-arquivo {
    margin-bottom: 20px;
    margin-right: 20px;
  }

  .email-company {
    margin-top: initial;
  }

  .email-error-message {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
  }
}

.tag-status {
  border-radius: 16px;
  padding: 1px 4px 1px 5px;
  align-items: flex-start;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin-left: 5px;
}

.tag-status.pending {
  border: 1px solid var(--Default-red-600, #DC2626);
  color: var(--Default-red-600, #DC2626);
  background: var(--Default-red-50, #FEF2F2);
}

.tag-status.in_progress {
  border: 1px solid var(--Default-yellow-600, #D97706);
  color: var(--Default-yellow-600, #D97706);
  background: var(--Default-yellow-50, #FFFBEB);
}

.tag-status.rejected {
  border: 1px solid var(--Default-red-600, #DC2626);
  color: var(--Default-red-600, #DC2626);
  background: var(--Default-red-50, #FEF2F2);
}

.tag-status.approved {
  border: 1px solid var(--Default-green-600, #059669);
  color: var(--Default-green-600, #059669);
  background: var(--Default-green-50, #ECFDF5);
}
</style>
